import { call, select, takeLatest } from 'redux-saga/effects'

import { saveUserMeta } from 'helpers/utils'
import { selectFavourites } from 'containers/Favourites/selectors'
import { TOGGLE_FAVOURITE, UPDATE_FAVOURITE_ORDER } from './constants'

function* toggleFavouriteWorker(action) {
  const state = yield select()
  const favourites = selectFavourites(state)
  yield call(saveUserMeta, 'favourites', favourites)
}

export default function* watcher() {
  yield takeLatest(TOGGLE_FAVOURITE, toggleFavouriteWorker)
  yield takeLatest(UPDATE_FAVOURITE_ORDER, toggleFavouriteWorker)
}
